module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PartOne"
    }
  }, [_vm._v("PART I")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PartOne#toc-anchor-5"
    }
  }, [_vm._v("Every Parent’s Nightmare")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_001"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_002"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_003"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PartTwo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PartTwo#toc-anchor-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Case of Divine Intervention")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PartThree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PartThree#toc-anchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayers Have Been Answered")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-THREE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FOUR")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 69
// module chunks = 0